import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/node_modules/@mui/icons-material/esm/Telegram.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/node_modules/@mui/icons-material/esm/X.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/node_modules/@mui/material/SvgIcon/SvgIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribedLayout"] */ "/home/runner/work/play/play/src/app/games/(details)/[uid]/SubscribedLayout.tsx");
